<div class="table table-hover table-condensed mb-0">
  <div class="row header-table">
    <div class="col-2">
      <span style="font-weight: bold;" i18n>
        Classificação
      </span>
    </div>
    <div class="col-6">
      <span style="font-weight: bold;" i18n>
        Nome
      </span>
    </div>
    <div class="col-1">
      <span style="font-weight: bold;" i18n>
        Quantidade
      </span>
    </div>
    <div class="col-2">
      <span style="font-weight: bold;" i18n>
        Valor
      </span>
    </div>
    <div class="col-1">
      <span style="font-weight: bold;" i18n>
        %
      </span>
    </div>

  </div>
  <div *ngFor="let classificacao of data">
    <div class="row tr-table">
      <div class="col-2">
        <button class="btn-expand" *ngIf="classificacao.showCities" (click)="toggleCities(classificacao)" i18n>
          <mat-icon>expand_more</mat-icon>
        </button>
        <button class="btn-expand" *ngIf="!classificacao.showCities" (click)="toggleCities(classificacao)" i18n>
          <mat-icon>expand_less</mat-icon>
        </button>
        <span style="font-weight: bold;" i18n>
          Cidades
        </span>
      </div>
      <div class="col-6">
        {{ classificacao.classificacao }}</div>
      <div class="col-1" i18n> {{ classificacao.quantidade }}</div>
      <div class="col-2" i18n>R$ {{ classificacao.valor | currency: "BRL" : "" }}</div>
      <div class="col-1">{{ classificacao.percentual_total }}%</div>
      <!--div class="col-3">
        <button (click)="toggleCities(classificacao)" i18n>
          {{ classificacao.showCities ? 'Ocultar Cidades' : 'Exibir Cidades' }}
        </button>
      </div-->
      <hr />
    </div>
    <div *ngIf="classificacao.showCities" class="nested-row city-div">
      <!-- <div class="row header-table">
        <div class="col-3">
          <span style="font-weight:bolder;" i18n>
            Cidade
          </span>
        </div>
        <div class="col-3">
          <span style="font-weight: bolder;" i18n>
            Quantidade
          </span>
        </div>
        <div class="col-3">
          <span style="font-weight: bolder;" i18n>
            Valor
          </span>
        </div>
        <div class="col-3">
          <span style="font-weight: bolder;" i18n>
            %
          </span>
        </div>
      </div> -->
      <div>
        <div style="border: 1px solid white;" *ngFor="let cidade of classificacao.cidades">
          <div class="row mt-1 mb-1">
            <div class="col-2">
              <button class="btn-expand" *ngIf="cidade.showClients" (click)="toggleClients(cidade)" i18n>
                <mat-icon>expand_more</mat-icon>
              </button>
              <button class="btn-expand" *ngIf="!cidade.showClients" (click)="toggleClients(cidade)" i18n>
                <mat-icon>expand_less</mat-icon>
              </button>
              <span style="font-weight: bold;" i18n>
                Cliente
              </span>
            </div>
            <div class="col-6">
              {{ cidade.cidade }}
            </div>
            <div class="col-1">{{ cidade.quantidade}}</div>
            <div class="col-2">R$ {{ cidade.valor | currency: "BRL" : "" }}</div>
            <div class="col-1">{{ cidade.percentual }} %</div>

          </div>
          <div class="div-clients" *ngIf="cidade.showClients">
            <!-- <div class="row mt-1 mb-1 ">
              <div class="col-3">
                <span style="font-weight: 700;" i18n>
                  Cliente
                </span>
              </div>
              <div class="col-3">
                <span style="font-weight: 700;" i18n>
                  Quantidade
                </span>
              </div>
              <div class="col-3">
                <span style="font-weight: 700;" i18n>
                  Valor
                </span>
              </div>
              <div class="col-3">
                <span style="font-weight: 700;" i18n>
                  %
                </span>
              </div>
            </div> -->
            <div class="row" style="border-bottom: 1px solid #e5e5e5 ;" *ngFor="let cliente of cidade.clientes">
              <div class="col-2"></div>
              <div class="col-6">{{ cliente.cliente }}</div>
              <div class="col-1">{{ cliente.quantidade }}</div>
              <div class="col-2">R$ {{ cliente.valor | currency: "BRL" : "" }}</div>
              <div class="col-1">{{ cliente.percentual }} %</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="row tr-table">
      <div class="col-2">
      </div>
      <div class="col-6">
        <b>
          TOTAL:
        </b>
      </div>
      <div class="col-1" i18n> 
        <b>{{qtdTotal}}</b>
      </div>
      <div class="col-2" i18n>
        <b>
          R$ {{ this.valorTotal | currency: "BRL" : "" }}
        </b>
        </div>
      <div class="col-1">
        <b>
          100%
        </b>
      </div>
    </div>
  </div>
</div>